// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Box from "@material-ui/core/Box";
import type { User as UserType } from '../../../types';
import UserForm from './UserForm';
import UserList from './UserList';

export type Props = $ReadOnly<{
    userType: 'admin' | 'driver',
    users: $ReadOnlyArray<string>,
    createUser: (user: UserType) => void,
    updateUser: (user: UserType) => void,
}>;

function UserManagement({ userType, users, createUser, updateUser }: Props) {
    const [formVisible, setFormVisible] = useState(false);
    const [editUser, setEditUser] = useState(null);

    const showForm = () => setFormVisible(true);
    const hideForm = () => {
        setFormVisible(false);
        setEditUser(null);
    };

    const handleEdit = (user) => {
        setEditUser(user);
        showForm();
    };

    const handleSubmit = (user) => {
        let promise;
        if(editUser) {
            const updatedUser = {
                ...user
            };

            delete updatedUser.email;

            promise = updateUser(updatedUser);
        }
        else {
            promise = createUser({
                ...user,
                isAdmin: userType === 'admin'
            });
        }

        promise
            .then(() => hideForm())
            .catch(e => {
                console.error(e);
            });

        return promise;
    };

    return (
        <Box m={2}>
            {!editUser &&
                <Button variant="contained" color="primary" fullWidth onClick={showForm}>
                    {userType === 'admin' ?
                        <FormattedMessage
                            id="options.users.addAdministrator"
                            defaultMessage="Add administrator"
                        />
                        :
                        <FormattedMessage
                            id="options.users.addDriver"
                            defaultMessage="Add driver"
                        />
                    }
                </Button>
            }

            {formVisible &&
                <UserForm
                    user={editUser}
                    onClose={hideForm}
                    onSubmit={handleSubmit}
                />
            }

            {!editUser && users &&
                <UserList
                    users={users}
                    onEdit={handleEdit}
                />
            }
        </Box>
    );
}

export default UserManagement;